import "./CheckoutStepper.css";
import {UserKey,MapPin,Truck,CreditCard} from "lucide-react";
const steps = [
  // {
  //   id: 1,
  //   title: "ورود",
  //   // icon: "👤",
  //   icon: <UserKey size={20}/>,
  // },

  {
    id: 1,
    title: "تکمیل آدرس",
    // icon: "📍",
    icon: <MapPin size={20} />,
  },

  {
    id: 2,
    title: "انتخاب روش ارسال",
    // icon: "🚚",
    icon: <Truck size={20}/>,
  },

  {
    id: 3,
    title: "پرداخت",
    // icon: "💳",
    icon: <CreditCard size={20}/>,
  },
];

export default function CheckoutStepper({ currentStep }) {
  const progress = ((currentStep - 1) * 100) / (steps.length - 1);

  return (
    <div className="checkout-stepper">
      <div className="checkout-stepper-line" />

      <div
        className="checkout-stepper-progress"
        style={{
          width: `${progress}%`,
        }}
      />

      {steps.map((step) => {
        const completed = step.id < currentStep;

        const active = step.id === currentStep;

        return (
          <div
            key={step.id}
            className={`checkout-step-item
                            ${completed ? "completed" : ""}
                            ${active ? "active" : ""}
                        `}
          >
            <div className="checkout-step-circle">
              {completed ? "✓" : step.icon}
            </div>

            <span>{step.title}</span>
          </div>
        );
      })}
    </div>
  );
}
